import { PublicClientApplication } from '@azure/msal-browser';

// Azure AD (Microsoft Entra) single-tenant app registration.
// Set these at build time in frontend/.env(.production):
//   REACT_APP_AZURE_CLIENT_ID=<Application (client) ID>
//   REACT_APP_AZURE_TENANT_ID=<Directory (tenant) ID>
const CLIENT_ID = process.env.REACT_APP_AZURE_CLIENT_ID || '';
const TENANT_ID = process.env.REACT_APP_AZURE_TENANT_ID || '';

// The "Sign in with Microsoft" button only shows when both are configured.
export const msEnabled = Boolean(CLIENT_ID && TENANT_ID);

const GRAPH_SCOPES = ['User.Read'];

let msalInstance = null;
let initPromise = null;

function getInstance() {
  if (!msalInstance) {
    msalInstance = new PublicClientApplication({
      auth: {
        clientId: CLIENT_ID,
        // Multi-tenant: accept work/school accounts from ANY Microsoft org
        // (e.g. saiteck.in AND innovasivtech.com). Access is still restricted
        // by the ITSM user list on the backend.
        authority: 'https://login.microsoftonline.com/organizations',
        redirectUri: window.location.origin,
      },
      cache: { cacheLocation: 'sessionStorage' },
    });
    initPromise = msalInstance.initialize();
  }
  return msalInstance;
}

// Opens the Microsoft sign-in popup and returns a Graph access token.
export async function getMicrosoftToken() {
  const inst = getInstance();
  await initPromise;
  const result = await inst.loginPopup({ scopes: GRAPH_SCOPES, prompt: 'select_account' });
  if (result.accessToken) return result.accessToken;
  const silent = await inst.acquireTokenSilent({ scopes: GRAPH_SCOPES, account: result.account });
  return silent.accessToken;
}

// True when the user closed/cancelled the popup — we treat that as a no-op.
export function isUserCancel(err) {
  const code = err?.errorCode || '';
  return code === 'user_cancelled' || code === 'popup_window_error' || code === 'interaction_in_progress';
}
